import { render, staticRenderFns } from "./HelpCenterLandingArticlesOverview.vue?vue&type=template&id=136bd921&"
import script from "./HelpCenterLandingArticlesOverview.vue?vue&type=script&lang=js&"
export * from "./HelpCenterLandingArticlesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports